import ApiService from "@/common/api.service";

const state = {
  locations: [],
  loadingLocations: false
};

const getters = {
  locations(state) {
    return state.locations;
  },
  loadingLocations(state) {
    return state.loadingLocations;
  }
}

const actions = {
  getLocations(context, body) {
    context.commit('setLoadingLocations', true);
    return new Promise((resolve, reject) => {
      ApiService.get("/commercial/locations", body)
        .then(response => {
          context.commit('setLocations', response.data.commercial_locations);
          context.commit('setLoadingLocations', false);
          resolve(response.data.commercial_locations);
        })
        .catch(({response}) => {
          context.commit('setLoadingLocations', false);
          reject(response);
        })
    })
  }
}

const mutations = {
  setLocations(state, locations) {
    state.locations = locations;
  },
  setLoadingLocations(state, status) {
    state.loadingLocations = status;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};